<template><span class="loader"></span></template>
<script setup></script>
<style scoped lang="scss">
.loader {
	width: 100%;
	height: 100%;
	max-width: 338px;
	max-height: 338px;
	border: 6px solid var(--vt-c-text-light-2);
	border-radius: 50%;
	display: inline-block;
	position: relative;
	box-sizing: border-box;
	animation: rotation 1s linear infinite;
}

.loader::after {
	content: "";
	box-sizing: border-box;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 356px;
	height: 356px;
	border-radius: 50%;
	border: 6px solid;
	border-color: $app-color transparent;
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
